import React, { Component } from "react";

import { Select, AppProvider } from "@shopify/polaris";

import MultiSelect from '@khanacademy/react-multi-select';

import Autocomplete from "react-autocomplete"

import InputValidator from "../utils/validators"

import PropTypes from "prop-types";

export default class FormField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ""
    };

  }

  componentDidMount(){
      this.setState({
          value : this.props.value
      })
  }

  componentWillReceiveProps(nextProps){
      this.setState({
          value : nextProps.value
      })
  }

  handleChange = (e) => {    
    const { name, value } = e.target;
    const isValid = InputValidator(this.props.field.type, value || "");
    
    if(this.props.dataContainer){
      this.props.fieldChange({ name, value }, isValid, this.props.dataContainer);
    }
    else{
      this.props.fieldChange({ name, value }, isValid);
    }

  }

  handleSelectChange = (value) => { 
    let isValid = false
    if(!this.props.field.meta.multiple){            
      if(value){
        isValid = true
      }
    }
    else{
      if (value.length !== 0){
        isValid = true
      }
    }
    
    const name = this.props.field.name    

    this.props.fieldChange({ name , value }, isValid)

  }
  renderSelect = () => {    
    const {
      label,     
      meta
    } = this.props.field
    const multiple = meta.multiple
    
    let options = null

    if(multiple){
      options = meta.options
    }    
    else{   
      //  Add a default null value
      options = [{ label : "" , value : undefined }].concat(meta.options)
    }
    
    if (multiple){ 
      return (
        <MultiSelect
            options={options}
            onSelectedChanged={this.handleSelectChange}
            selected={this.state.value}                        
        />
        )
    }
    return (
    <AppProvider>
      <Select
        label={<b>{label}</b>}
        options={options}
        onChange={this.handleSelectChange}
        value={this.state.value || ""}
      />
    </AppProvider>
    )
   
  }

  renderAutocomplete = () => {
    const {
      name,
      label,      
      container_css,
      placeholder,
      meta
    } = this.props.field
    let options = meta.options
 

    return (
      <div className={"mb-3 " + container_css} key={name}>
        <label><b>{label}</b></label>
        <br />
        <Autocomplete
          getItemValue={(item) => item.label}
          menuStyle={{
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '90%',
            position: 'fixed',
            overflow: 'auto',
            maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
            zIndex : 999,
          }}

          wrapperStyle={{}}
          inputProps={{ name : name,placeholder:placeholder }}
          items={options}
          shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
          renderItem={(item, isHighlighted) =>
            <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
              {item.label}
            </div>
          }
          value={this.state.value}
          onChange={this.handleChange}
          onSelect={this.handleSelectChange}
          />
      </div>
    )
  }
  
  render() {
    const {
      name,
      type,
      label,      
      container_css,
      input_css,
      placeholder,
      meta
    } = this.props.field;

    if(type === "select"){
      return <div className={container_css || ""}> {this.renderSelect()} </div>
    }

    if(meta && meta.autocomplete){
      return <div className={container_css || ""}> {this.renderAutocomplete()} </div>
    }

    if (type === "textarea") {
      const rows = meta.rows
      const cols = meta.cols
      const line_break = meta.line_break
      return (
        <div className={container_css || ""}>
          <label>{label}</label>          
          <textarea
            className={"form-control " + input_css}
            name={name}
            type={type}
            onChange={this.handleChange}
            onInput={this.handleChange}      
            value={this.props.value}
            rows={rows || "10"}
            cols = {cols || ""}
          />
          <br hidden={!line_break} />
        </div>
      );
    }

    return (        
        <div className={"mb-3 " + container_css || ""}>
          <label><b>{label}</b></label>
          <br />
          <input
              className={input_css}
              name={name}
              placeholder={placeholder}
              type={type}
              onChange={this.handleChange}
              onInput={this.handleChange}
              value={this.props.value}
          />
        </div>        
    ); 
  }
}

FormField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,    
    container_css : PropTypes.string,
    input_css: PropTypes.string,
    input_type: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.array
  }),
  value: PropTypes.any.isRequired,
  fieldChange: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/Components/FormField.js